import { render } from "./ConfirmEmailDialog.vue?vue&type=template&id=2a357418&scoped=true"
import script from "./ConfirmEmailDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmEmailDialog.vue?vue&type=script&lang=js"

import "./ConfirmEmailDialog.vue?vue&type=style&index=0&id=2a357418&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a357418"]])

export default __exports__